var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBadgeError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.2354,
    cy: 16.7985,
    r: 13.6042,
    transform: "rotate(60 17.2354 16.7985)",
    fill: "#EB5757",
    stroke: "#EB5757",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.9688 10.3896C23.9688 10.3896 23.127 11.2314 17.716 16.6424C12.305 22.0534 10.5013 23.8571 10.5013 23.8571",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.502 10.3896C10.502 10.3896 11.3437 11.2314 16.7547 16.6424C22.1657 22.0534 23.9694 23.8571 23.9694 23.8571",
    stroke: "white",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadgeError);
export default __webpack_public_path__ + "static/media/Badge Error.9cb93cc84e41cbbad0f2754f4106c93f.svg";
export { ForwardRef as ReactComponent };